export default {
      id: "i-file-new-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/sprite.svg#i-file-new",
      toString: function () {
        return this.url;
      }
    }